import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
    const preview = document.getElementById("inspirationPreview");
    const links = document.querySelectorAll("[data-cover]");

    links.forEach(link => {
        link.addEventListener("mouseenter", () => {
            const newSrc = link.getAttribute("data-cover");
            if (!newSrc) return;

            gsap.fromTo(preview,
                { opacity: 0, filter: "blur(10px)" },
                {
                    opacity: 1,
                    filter: "blur(0px)",
                    duration: 0.5,
                    ease: "power2.out",
                    onStart: () => { preview.src = newSrc; }
                }
            );
        });
    });
});
